module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "log"
  }, [_c('div', {
    staticClass: "view-title"
  }, [_c('translate', [_vm._v("Log")])], 1), _vm._v(" "), _c('div', {
    staticClass: "log-search"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": _vm.attrText.command
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch(_vm.searchForm)
      }
    },
    model: {
      value: (_vm.searchForm.keywords),
      callback: function($$v) {
        _vm.searchForm.keywords = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "searchForm.keywords"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        _vm.onSearch(_vm.searchForm)
      }
    }
  }, [_c('translate', [_vm._v("Search")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onShowLogSearch()
      }
    }
  }, [_c('translate', [_vm._v("Advanced Search")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-right"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.getTranTest(_vm.log.totalNum)) + "\n\t\t\t\t\t"), _c('a', {
    attrs: {
      "href": _vm.importUrl,
      "disabled": !_vm.log.totalNum,
      "target": "_blank"
    }
  }, [_c('translate', [_vm._v("Download Report")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px",
      "color": "#20a0ff",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.videoReply
    }
  }, [_c('translate', [_vm._v("Video Reply")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [(_vm.log.tags.length) ? _c('div', {
    staticClass: "searchTag"
  }, _vm._l((_vm.log.tags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "closable": true
      },
      on: {
        "close": function($event) {
          _vm.onCloseTag(tag)
        }
      }
    }, [(tag.val == 'transfer') ? _c('span', [_vm._v(_vm._s(((tag.text) + ":文件传输")))]) : _c('span', [_vm._v(_vm._s(tag.key === 'unsafe_mode' ? tag.text : ((tag.text) + ":" + (tag.val))))])])
  })) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.log.list,
      "height": _vm.tableMaxHeight
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.operator
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "avatar-wrapper"
        }, [_c('img', {
          staticClass: "avatar",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(scope.row.account_name) + "（" + _vm._s(scope.row.client_ip_address) + "）")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.account))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.workgroup,
      "prop": "project_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.operationObj
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-start"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/mysql.png",
            "alt": "",
            "width": "16",
            "height": "16"
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/mssql.png",
            "alt": "",
            "width": "16",
            "height": "14"
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'oracle') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Oracle",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin": "3px 5px 0 0"
          },
          attrs: {
            "src": "../../../static/images/oracle.png",
            "alt": "",
            "width": "16",
            "height": "14"
          }
        })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.resource_name) + "（" + _vm._s(scope.row.resource_ip_address) + "）")])], 1), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(scope.row.login_username || '-'))]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin": "0 5px"
          }
        }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.wayMap(scope.row.way)))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.operationTime
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("开始：" + _vm._s(_vm._f("moment")((scope.row.start_date * 1000), 'YYYY-MM-DD HH:mm:ss')))]), _vm._v(" "), _c('p', [_vm._v("结束：" + _vm._s(_vm._f("moment")((scope.row.date * 1000), 'YYYY-MM-DD HH:mm:ss')))]), _vm._v(" "), _c('p', [_vm._v("时长：" + _vm._s(_vm.durTime(scope.row.date, scope.row.start_date)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action,
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.way != 'rds' && scope.row.way != 'mysql' && scope.row.way != 'mssql' && scope.row.way !== 'transfer' && scope.row.way != 'postgresql' && scope.row.way != 'oracle' && scope.row.play != 0) ? _c('a', {
          staticClass: "play play-url",
          attrs: {
            "href": scope.row.playbackLink,
            "target": "_blank"
          }
        }, [_c('translate', [_vm._v("Play")])], 1) : _vm._e(), _vm._v(" "), (scope.row.way != 'rdp') ? _c('a', {
          staticClass: "view-url",
          on: {
            "click": function($event) {
              _vm.viewLog(scope.row, false)
            }
          }
        }, [_c('translate', [_vm._v("View")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "down-url",
          on: {
            "click": function($event) {
              _vm.downLog(scope.row, false)
            }
          }
        }, [_c('translate', [_vm._v("Download")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.log.totalPage > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "total": _vm.log.totalPage,
      "page-size": 10,
      "current-page": _vm.log.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.log.currentPage = $event
      },
      "current-change": _vm.onChangePage
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c(_vm.currentRightPanel, {
    tag: "component",
    attrs: {
      "items": _vm.rightPanelData
    },
    on: {
      "onClosePanel": _vm.onClosePanel,
      "callback": _vm.onSearch
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "日志解冻",
      "visible": _vm.freezeShow,
      "top": "20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.freezeShow = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pollingLoading),
      expression: "pollingLoading"
    }],
    staticClass: "dialog-content",
    attrs: {
      "element-loading-text": "日志正在解冻中，请稍等..."
    }
  }, [(_vm.pollingCode == 'OSSFileAvailable') ? _c('p', {
    staticClass: "text"
  }, [_vm._v("解冻完成，文件正在下载...")]) : _c('p', {
    staticClass: "text"
  }, [_vm._v("检测到您所选择的日志文件目前处于\"冷冻\"归档状态，如您需要继续\"下载\"，请点击\"确认\"发起解冻请求。日志文件\"解冻\"通常需要5-10分钟左右，请耐心等待。")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pollingLoading,
      "link": ""
    },
    on: {
      "click": function($event) {
        _vm.freezeShow = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.pollingLoading || _vm.pollingCode == 'OSSFileArchived') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.pollingLoading
    },
    on: {
      "click": _vm.handleFreezeConfirm
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "日志内容查看",
      "visible": _vm.viewLogShow,
      "width": "90%",
      "top": "20px"
    },
    on: {
      "update:visible": function($event) {
        _vm.viewLogShow = $event
      },
      "close": _vm.closeViewLogDialog
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.viewLogLoading),
      expression: "viewLogLoading"
    }],
    staticClass: "log-view-content",
    attrs: {
      "element-loading-text": "加载日志内容中..."
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.logContent))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.logContent),
      expression: "logContent",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.copySuccess),
      expression: "copySuccess",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.copyError),
      expression: "copyError",
      arg: "error"
    }],
    attrs: {
      "type": "primary"
    }
  }, [_c('translate', [_vm._v("Copy")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.viewLogShow = false
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-afccc170"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/logs.vue
// module id = 607
// module chunks = 4 5 6